import { createPromiseAction } from "@adobe/redux-saga-promise";

export const actionTypes = {
  ACTIVITY_DATE_PERIOD: "ACTIVITY_DATE_PERIOD",
  GET_ALL_EMPLOYEES: "GET_ALL_EMPLOYEES",
  RESULT_GET_ALL_EMPLOYEES: "RESULT_GET_ALL_EMPLOYEES",
  CREATE_ACTION: "CREATE_ACTION",
  UPDATE_ACTION: 'UPDATE_ACTION',
  DELETE_ACTION: 'DELETE_ACTION',
  EMPLOYEE_VALIDATION: "EMPLOYEE_VALIDATION",
  PERMISSION_LIST: "PERMISSION_LIST"
};
export function initialize() {
  const init = {};
  return { type: actionTypes.INITIAL_STATE, init };
}
export function getEmployees() {
  return { type: actionTypes.GET_ALL_EMPLOYEES };
}
export function createAction(employeeData, permissons) {
  return { type: actionTypes.CREATE_ACTION, employeeData, permissons };
}
export function updateAction(employeeData) {
  return { type: actionTypes.UPDATE_ACTION, employeeData };
}
export function deleteActionRequest(id) {
  return { type: actionTypes.DELETE_ACTION, id };
}
export function employeeValidation(resolve, name, value, business_id) {
  return { type: actionTypes.EMPLOYEE_VALIDATION, resolve, name, value, business_id };
}

export const getPermissionList = createPromiseAction(actionTypes.PERMISSION_LIST);